<template>
    <div class="bar" v-if="showBar">
        <div class="mb p-f" v-if="isMobile">
            <div @click="goLink(item)" class="bar-item d-b f-l" v-for="(item,index) in resetInfo.list" :key="index" :style="{width:100/resetInfo.list.length+'%'}">
                <img :src="item.normalBg ? item.normalBg : item.activeBg" alt="">
            </div>
        </div>
        <div class="pc p-f" v-else>
            <a :href="item.name == 'outLink' ? item.path : item.basePath" class="bar-item d-b" v-for="(item,index) in resetInfo.pcList" :key="index">
                <img :src="item.normalBg ? item.normalBg : item.activeBg" alt="">
            </a>
        </div>
    </div>
</template>
<style lang="less" scoped>
    .bar {
        width: 100%;
        .mb {
            z-index: 3;
            bottom: 0;
            width: 100%;
            .bar-item {
                img {
                    height: 1.333333rem;
                }
            }
        }
        .pc {
            width: 166px;
            top: 450px;
            left: 80%;
            a {
                width: 166px;
                height: 40px;
                margin-bottom: 5px;
                img {
                    width: auto;
                }
            }
        }
    }
</style>

<script>
    import Util from "@util/index.js";
    export default {
        props: ['info', 'lan'],
        data() {
            return {
                isMobile: true,
                showBar: false
            }
        },
        mounted() {
            Util.deviceType() == 'mb' ? this.isMobile = true : this.isMobile = false;
            this.showBar = true; //mounted再显示bar，消除页面渲染的时候忽然的切换。
        },
        computed: {
            resetInfo() {
                this.info.list.forEach(e => {
                    if (e.name == this.info.path) {
                        delete e.normalBg;
                    }
                });
                this.info.pcList.forEach(e => {
                    if (e.name == this.info.path) {
                        delete e.normalBg;
                    }
                });
                return this.info;
            }
        },
        methods: {
            goLink(_item) {
                window.location.href = (_item.name == 'outLink') ? _item.path : _item.basePath;
                Util.trackGA('点击', this.lan + '点击跳转' + _item.path, this.lan + '点击跳转' + _item.path);
            }
        }
    }
</script>




// WEBPACK FOOTER //
// client/smsgz/components/common/bar/index.vue